/**
 * AdvisorsAssignedGraph component module.
 * @module shared/components/AdvisorsAssignedGraph
 *
 */
import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import Pie from '../../../../shared/components/graphs/Pie';
import {_openModal} from '../../../../shared/reducers/modals';
import {connect} from 'react-redux';
import {getColorListPrimary, getColor} from '../../../../shared/utils/colors';
import {getCounts} from '../../../../shared/utils/containerUtils';
import {LoadingSpinner} from '../../../../shared';
import Row from '../../../../shared/components/Row';

const AdvisorsAssignedGraph = ({session, openModal}) => {
  const colorList = [...getColorListPrimary()];

  const {data: swrCounts} = getCounts({
    session: session,
    options: {onError: err => openModal({type: 'Error', title: 'Advisors Assigned Branches', err})},
  });

  const formattedData = useMemo(() => swrCounts
    && (swrCounts.advisors && swrCounts.advisors.total
      ? [
        {
          id: 'Assigned',
          name: 'Assigned',
          color: getColor(colorList),
          y: swrCounts.advisors.assigned,
          // y: swrCounts.advisors.assigned / swrCounts.advisors.total,
        },
        {
          id: 'Unassigned',
          name: 'Unassigned',
          color: getColor(colorList),
          y: swrCounts.advisors.unassigned,
          // y: swrCounts.advisors.unassigned / swrCounts.advisors.total,
        },
      ]
      : [{name: 'No Advisors', color: '#797B83', y: 1}]), [swrCounts]);

  if (!formattedData) {
    return <LoadingSpinner/>;
  }
  return <Row height={'100px'}
              alignSubRow={'stretch'}
              alignItems={'stretch'}
              layout={{grow: 1}}>
    <Pie data={formattedData}/>
  </Row>;
};

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(null, mapDispatchToProps)(AdvisorsAssignedGraph);

AdvisorsAssignedGraph.propTypes = {
  openModal: PropTypes.func,
  session: PropTypes.object,
};
